import { isEmpty } from 'lodash';
import * as yup from 'yup';

export const addressBookSchema = yup.object({
  name: yup
    .string()
    .required('Location Name is required')
    .max(150, 'Maximum of 150 characters'),
  description: yup
    .string()
    .nullable()
    .notRequired()
    .max(100, 'Maximum of 100 characters'),
  address1: yup
    .string()
    .required('Address Line 1 is required')
    .max(100, 'Maximum of 100 characters'),
  addressLine2: yup
    .string()
    .nullable()
    .notRequired()
    .max(100, 'Maximum of 100 characters'),
  city: yup
    .string()
    .required('City is required')
    .max(50, 'Maximum of 50 characters'),
  state: yup
    .string()
    .required('State is required')
    .max(2, 'Maximum of 2 characters'),
  zip: yup.string().max(10).required('Zip is required'),
  countryCode: yup.string().required('Country Code is required'),
  contactName: yup.string().nullable().max(50, 'Maximum of 50 characters'),
  contactPhone: yup.string().when((value) => {
    return isEmpty(value[0])
      ? yup.string().nullable().notRequired()
      : yup.string().min(10, 'Phone number must be at least 10 digits');
  }),
  openTimeFrom: yup.string(),
  openTimeTo: yup.string(),
  pickupHoursFrom: yup.string().nullable().notRequired(),
  pickupHoursTo: yup.string().nullable().notRequired(),
  pickupHoursClosed: yup.boolean().nullable().notRequired(),
  pickupHoursNotes: yup
    .string()
    .nullable()
    .notRequired()
    .max(500, 'Maximum of 500 characters'),
  receivingHoursFrom: yup.string().nullable().notRequired(),
  receivingHoursTo: yup.string().nullable().notRequired(),
  receivingHoursClosed: yup.boolean().nullable().notRequired(),
  receivingUsePickupHours: yup.boolean().nullable().notRequired(),
  receivingHoursNotes: yup
    .string()
    .nullable()
    .notRequired()
    .max(500, 'Maximum of 500 characters'),
  appointmentType: yup.string().nullable().notRequired(),
  schedulingMethod: yup.string().nullable().notRequired(),
  specialInstructions: yup
    .string()
    .nullable()
    .notRequired()
    .max(2000, 'Maximum of 2000 characters'),
  drivingDirections: yup
    .string()
    .nullable()
    .notRequired()
    .max(2000, 'Maximum of 2000 characters'),
  internalNote: yup
    .string()
    .nullable()
    .notRequired()
    .max(2000, 'Maximum of 2000 characters'),
  isDefaultAddress: yup.boolean(),
});
